import { useNotificationChannel } from '../useNotificationChannel';

import { ChannelFieldsProps } from './types';

export function UnknownChannelFields({ index }: ChannelFieldsProps) {
  const channel = useNotificationChannel(index);

  return (
    <div className="border-blue-400 rounded-sm border-l-4 bg-[var(--bg-body-color)] p-3 text-sm text-[var(--text-muted-color)]">
      <div className="flex items-start">
        <div className="text-blue-400 mr-2">ℹ️</div>
        <div>
          Configuration fields for {channel.type} will be available once this
          channel type is fully implemented.
        </div>
      </div>
    </div>
  );
}
